/* Temporary coming-soon overlay (snippets/ngf-coming-soon.liquid). Ported from the design handoff "Coming Soon.dc.html". */
(function () {
  var html = document.documentElement;
  var root = document.getElementById('ngf-cs');
  if (!root || html.classList.contains('ngf-cs-off')) return;

  var paint = root.querySelector('.ngf-cs__paint');
  var cv = paint.querySelector('canvas');
  var hint = root.querySelector('.ngf-cs__hint');
  var title = root.querySelector('.ngf-cs__title');
  var main = root.querySelector('.ngf-cs__main');
  var done = root.querySelector('[data-ngf-done]'); // form just posted: no painting
  var desktop = matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)');
  var reduce = matchMedia('(prefers-reduced-motion: reduce)');
  var R = 220;
  var ease = 'cubic-bezier(0.23, 1, 0.32, 1)';
  var img, ctx, last, sampleCv, timer, phase = 0, firstMoveT = 0, lastCheck = 0, celebrated = false;

  if (root.dataset.scope === 'viewport') root.appendChild(paint);

  // Keep keyboard and screen readers inside the overlay. Theme parts only, so app banners (cookies) stay usable.
  document.querySelectorAll('#MainContent, .shopify-section-group-header-group, .shopify-section-group-footer-group, cart-drawer, .skip-to-content-link').forEach(function (el) {
    el.inert = true;
  });

  /* Painting */
  function setup() {
    var on = !done && !celebrated && desktop.matches && !!root.dataset.painting;
    paint.hidden = !on;
    if (!on) { ctx = null; return Promise.resolve(); }
    if (!img) { img = new Image(); img.src = root.dataset.painting; }
    var loaded = img.complete ? Promise.resolve() : new Promise(function (r) { img.onload = img.onerror = r; });
    return loaded.then(draw);
  }

  function draw() {
    if (!img.naturalWidth) paint.hidden = true;
    if (paint.hidden) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), w = cv.clientWidth, h = cv.clientHeight;
    cv.width = w * dpr; cv.height = h * dpr;
    ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.globalCompositeOperation = 'source-over';
    var iw = img.naturalWidth, ih = img.naturalHeight, s = Math.max(w / iw, h / ih);
    ctx.drawImage(img, (w - iw * s) / 2, (h - ih * s) / 2, iw * s, ih * s);
    ctx.globalCompositeOperation = 'destination-out';
    last = null; firstMoveT = 0;
    hint.style.opacity = '1';
    alignHint();
  }

  function alignHint() {
    var b = title.getBoundingClientRect();
    if (b.height) hint.style.top = (b.top - paint.getBoundingClientRect().top + b.height / 2) + 'px';
  }

  // Organic blob, partially erasing; repeated passes clear further.
  function stamp(x, y) {
    var g = ctx.createRadialGradient(x, y, 0, x, y, R);
    g.addColorStop(0, 'rgba(0,0,0,0.22)');
    g.addColorStop(0.4, 'rgba(0,0,0,0.16)');
    g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g;
    phase += 0.035;
    ctx.beginPath();
    for (var i = 0; i <= 48; i++) {
      var a = (i / 48) * Math.PI * 2;
      var k = 1 + 0.16 * Math.sin(3 * a + phase) + 0.10 * Math.sin(5 * a - phase * 1.7 + 1.3) + 0.06 * Math.sin(7 * a + phase * 2.3 + 2.1);
      var px = x + Math.cos(a) * R * 0.82 * k, py = y + Math.sin(a) * R * 0.82 * k;
      if (i) ctx.lineTo(px, py); else ctx.moveTo(px, py);
    }
    ctx.closePath();
    ctx.fill();
  }

  function onMove(e) {
    if (!ctx) return;
    var cr = cv.getBoundingClientRect(), x = e.clientX - cr.left, y = e.clientY - cr.top;
    if (y < -R || y > cr.height + R) { last = null; return; }
    if (last) {
      var dx = x - last.x, dy = y - last.y, n = Math.ceil(Math.hypot(dx, dy) / Math.max(4, R / 6));
      for (var i = 1; i <= n; i++) stamp(last.x + dx * i / n, last.y + dy * i / n);
    } else stamp(x, y);
    last = { x: x, y: y };
    if (!firstMoveT) firstMoveT = performance.now();
    checkCleared();
    var b = hint.firstElementChild.getBoundingClientRect(), pad = 120;
    if (e.clientX >= b.left - pad && e.clientX <= b.right + pad && e.clientY >= b.top - pad && e.clientY <= b.bottom + pad) hint.style.opacity = '0';
  }

  // Union of the central block's visible boxes.
  function contentRect() {
    var l = Infinity, t = Infinity, r = -Infinity, bt = -Infinity;
    main.querySelectorAll('img, p, span, input, button, label').forEach(function (c) {
      var b = c.getBoundingClientRect();
      if (!b.width || !b.height) return;
      l = Math.min(l, b.left); t = Math.min(t, b.top); r = Math.max(r, b.right); bt = Math.max(bt, b.bottom);
    });
    return l < r ? { left: l, top: t, width: r - l, height: bt - t } : null;
  }

  // Mean alpha of the painting left over the content (1 = covered, 0 = clear).
  function regionAlpha() {
    var b = contentRect();
    if (!b) return 0;
    var cr = cv.getBoundingClientRect(), k = cv.width / cr.width;
    var s = sampleCv || (sampleCv = document.createElement('canvas'));
    s.width = 48; s.height = 16;
    var sc = s.getContext('2d', { willReadFrequently: true });
    sc.clearRect(0, 0, 48, 16);
    sc.drawImage(cv, (b.left - cr.left) * k, (b.top - cr.top) * k, b.width * k, b.height * k, 0, 0, 48, 16);
    var d = sc.getImageData(0, 0, 48, 16).data, sum = 0;
    for (var i = 3; i < d.length; i += 4) sum += d[i];
    return sum / (d.length / 4) / 255;
  }

  function checkCleared() {
    var now = Date.now();
    if (celebrated || now - lastCheck < 200) return;
    lastCheck = now;
    if (regionAlpha() < 0.15) celebrate();
  }

  function celebrate() {
    celebrated = true;
    clearInterval(timer);
    hint.style.opacity = '0';
    var hide = function () { ctx = null; paint.hidden = true; };
    if (cv.animate && document.visibilityState !== 'hidden') {
      cv.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 1600, easing: ease, fill: 'forwards' }).onfinish = hide;
    } else hide();
  }

  /* Gallery */
  var gallery = root.querySelector('.ngf-cs__gallery');
  var grid = gallery.querySelector('.ngf-cs__grid');
  var opener = root.querySelector('[data-ngf-open]');
  var closing = false;

  function openGallery() {
    if (!grid.firstChild) {
      JSON.parse(document.getElementById('ngf-cs-gallery').textContent).forEach(function (g) {
        var tile = document.createElement('div'), im = new Image();
        tile.className = 'ngf-cs__tile';
        tile.style.aspectRatio = g.ratio;
        im.loading = 'lazy';
        im.alt = g.alt || 'The New Generation Festival, past edition';
        im.src = g.src;
        tile.appendChild(im);
        grid.appendChild(tile);
      });
    }
    gallery.hidden = false;
    gallery.scrollTop = 0;
    gallery.querySelector('[data-ngf-close]').focus({ preventScroll: true });
    if (!gallery.animate) return;
    var vh = window.innerHeight;
    gallery.animate(reduce.matches ? [{ opacity: 0 }, { opacity: 1 }] : [{ transform: 'translateY(100%)' }, { transform: 'translateY(0)' }], { duration: reduce.matches ? 200 : 500, easing: 'cubic-bezier(0.32, 0.72, 0, 1)' });
    Array.prototype.map.call(grid.children, function (t) { return { t: t, b: t.getBoundingClientRect() }; })
      .filter(function (o) { return o.b.top < vh; })
      .sort(function (a, b) { return (a.b.top + a.b.left * 0.6) - (b.b.top + b.b.left * 0.6); })
      .forEach(function (o, i) {
        var kf = reduce.matches ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translateY(64px) scale(0.96)' }, { opacity: 1, transform: 'translateY(0) scale(1)' }];
        o.t.animate(kf, { duration: reduce.matches ? 200 : 700, delay: 220 + Math.min(i, 14) * 55, easing: ease, fill: 'backwards' });
      });
  }

  function closeGallery() {
    if (closing || gallery.hidden) return;
    var finish = function () { closing = false; gallery.hidden = true; if (opener) opener.focus({ preventScroll: true }); };
    if (!gallery.animate || document.visibilityState === 'hidden') return finish();
    closing = true;
    var a = gallery.animate(reduce.matches ? [{ opacity: 1 }, { opacity: 0 }] : [{ transform: 'translateY(0)' }, { transform: 'translateY(100%)' }], { duration: reduce.matches ? 150 : 320, easing: 'cubic-bezier(0.32, 0.72, 0, 1)', fill: 'forwards' });
    a.onfinish = function () { a.cancel(); finish(); };
  }

  if (opener) opener.addEventListener('click', openGallery); // no photos in the section: no button
  gallery.querySelector('[data-ngf-close]').addEventListener('click', closeGallery);
  window.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeGallery(); });

  /* Newsletter: validate here, Shopify's customer form does the rest (page reloads with the result). */
  var form = root.querySelector('.ngf-cs__form');
  var email = form && form.querySelector('input[type="email"]');
  if (email) {
    var consent = form.querySelector('input[type="checkbox"]');
    var status = form.querySelector('.ngf-cs__status');
    form.noValidate = true;
    form.addEventListener('submit', function (e) {
      var msg = !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value) ? "This email address doesn't look right."
        : !consent.checked ? 'Please agree to the processing of your data to continue.' : '';
      if (msg) { e.preventDefault(); status.textContent = msg; }
    });
    consent.addEventListener('change', function () { status.textContent = ''; });
  }

  /* Start */
  window.addEventListener('pointermove', onMove);
  html.addEventListener('pointerleave', function () { last = null; });
  window.addEventListener('blur', function () { last = null; });
  window.addEventListener('resize', function () { if (ctx) draw(); });
  desktop.addEventListener('change', function () { if (!celebrated) setup(); });
  timer = setInterval(function () { if (ctx && firstMoveT && performance.now() - firstMoveT >= 12000) celebrate(); }, 250);

  Promise.all([setup(), document.fonts ? document.fonts.ready : null]).then(function () {
    alignHint();
    html.classList.remove('ngf-cs-loading');
    root.focus({ preventScroll: true });
  });
})();
